/* Load the 3D engines only as their explorer approaches the viewport. */
(()=>{
 const jobs=[...document.querySelectorAll('[data-evo-deferred-script]')];
 jobs.forEach(job=>{
  let pending=false,complete=false;
  const load=()=>{if(pending||complete)return;pending=true;const script=document.createElement('script');script.src=job.dataset.src;script.async=true;script.onload=()=>{complete=true;observer?.disconnect();};script.onerror=()=>{pending=false;script.remove();};document.head.append(script);};
  const observer='IntersectionObserver' in window?new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting))load();},{rootMargin:'400px'}):null;
  document.querySelectorAll(job.dataset.target).forEach(host=>{if(observer)observer.observe(host);else load();host.addEventListener('pointerdown',load,{once:true});host.addEventListener('focusin',load,{once:true});});
  document.addEventListener('shopify:section:load',load);
 });
})();
